// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"244":"681ce62adb63ca5c","357":"9c36d10649c3f12b","488":"b4d41d702fe6f20d","917":"26602415a833f999"}[chunkId] + ".js";
};